import React from "react";
import { Link } from "../i18n/router";
import { BookOpen, PenLine } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../hooks/use-toast";
import { practiceTypes } from "../data/mock";

const BlogPage = () => {
  const { user } = useAuth();
  const { toast } = useToast();

  return (
    <div className="eunoia-page">
      <div className="eunoia-container">
        {/* Header */}
        <div className="eunoia-text-center eunoia-space-lg">
          <h1 className="eunoia-title-large mb-6">
            Блог сообщества
          </h1>
          <p className="eunoia-body-large max-w-2xl mx-auto">
            Делимся знаниями, опытом и вдохновением на пути духовного развития
          </p>
        </div>

        {/* Empty State */}
        <div className="eunoia-surface p-12 text-center mb-12">
          <div 
            className="inline-flex items-center justify-center w-24 h-24 rounded-full mb-8"
            style={{backgroundColor: 'var(--eunoia-accent-whisper)'}}
          >
            <BookOpen className="h-12 w-12" style={{color: 'var(--eunoia-accent)'}} />
          </div>
          
          <h2 className="eunoia-title-medium mb-4">
            Пока нет статей
          </h2>
          
          <p className="eunoia-body-large mb-8 max-w-lg mx-auto">
            Станьте первым, кто поделится своим опытом духовных практик с сообществом
          </p>

          <button
            type="button"
            onClick={() => toast({ title: "Функция скоро появится" })}
            className="eunoia-btn-primary inline-flex items-center gap-2"
            data-testid="blog-write-article-btn"
          >
            <PenLine className="h-5 w-5" />
            Написать статью
          </button>
        </div>

        {/* Categories - links to Events page */}
        <div className="eunoia-surface p-8">
          <h3 className="eunoia-title-small mb-6 text-center">
            Найти события по категориям
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {practiceTypes.map((category) => (
              <Link
                key={category.value}
                to={`/events?category=${category.value}`}
                className="px-4 py-2 text-sm rounded-full transition-all duration-300"
                style={{
                  textDecoration: 'none',
                  backgroundColor: 'var(--eunoia-accent-whisper)',
                  color: 'var(--eunoia-deep)'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = 'var(--eunoia-accent)';
                  e.target.style.color = 'white';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'var(--eunoia-accent-whisper)';
                  e.target.style.color = 'var(--eunoia-deep)';
                }}
              >
                {category.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
